/**
 * 사용자 , 관리자 공통 컴포넌트
 * */
import $ from "jquery";

document.addEventListener('DOMContentLoaded', () => {

	// ✅ SlimSelect 초기화
	document.querySelectorAll('.slim-select').forEach(select => {
		new SlimSelect({
			select  : select,
			settings: {
				showSearch     : false,
				placeholderText: select.getAttribute('placeholder') || 'Select Value',
			}
		});

		if (select.classList.contains('custom')) {

			const title = select.dataset.title;
			if (!title) return;

			const selectClasses = Array.from(select.classList).filter(cls => !['slim-select', 'custom'].includes(cls));
			if (selectClasses.length === 0) return;

			const selector = selectClasses.map(cls => `.ss-main.${cls}`).join('');
			const wrapper = document.querySelector(selector);
			if (!wrapper) return;

			// .data-title 삽입
			let titleDiv;
			if (!wrapper.querySelector('.data-title')) {
				titleDiv = document.createElement('div');
				titleDiv.className = 'data-title';
				titleDiv.textContent = title;

				const ssValues = wrapper.querySelector('.ss-values');
				if (ssValues) wrapper.insertBefore(titleDiv, ssValues);
			}

			// 기존 floating 제거 후 새로 생성
			const existingFloating = wrapper.querySelector('.data-title.data-title-floating');
			if (existingFloating) existingFloating.remove();

			const floatingTitle = document.createElement('div');
			floatingTitle.className = 'data-title data-title-floating';
			floatingTitle.textContent = title;
			wrapper.appendChild(floatingTitle);

			// span으로 width 계산
			const tempSpan = document.createElement('span');
			tempSpan.textContent = title;
			tempSpan.style.position = 'absolute';
			tempSpan.style.visibility = 'hidden';
			tempSpan.style.whiteSpace = 'nowrap';
			tempSpan.style.fontSize = window.getComputedStyle(floatingTitle).fontSize;
			tempSpan.style.fontFamily = window.getComputedStyle(floatingTitle).fontFamily;
			document.body.appendChild(tempSpan);

			const floatingWidth = tempSpan.getBoundingClientRect().width + 20;
			tempSpan.remove();

			// 데이터 저장 및 적용
			select.dataset.paddingLeft = floatingWidth;
			applyPaddingLeft(select);

			select.addEventListener('change', () => {
				setTimeout(() => {
					applyPaddingLeft(select);
				}, 50);  // 50ms 딜레이
			});

		}
	});

	// padding-left 재적용 함수
	function applyPaddingLeft(select) {
		const paddingLeft = select.dataset.paddingLeft;
		console.log('paddingLeft:', paddingLeft);
		if (!paddingLeft) return;

		const selectClasses = Array.from(select.classList).filter(cls => !['slim-select', 'custom'].includes(cls));
		selectClasses.forEach(cls => {
			const wrappers = document.querySelectorAll(`.ss-content.${cls}`);
			wrappers.forEach(wrapper => {
				const options = wrapper.querySelectorAll('.ss-option');
				options.forEach(opt => {
					opt.style.paddingLeft = `${paddingLeft}px`;
				});
			});
		});
	}

	window.applyPaddingLeft = applyPaddingLeft;

	/*
	| ----------------------------------------------------------------------------------------
	| 반응형에서 검색영역 더보기 함수입니다.
	| ----------------------------------------------------------------------------------------
	*/
	function toggleSrch() {
		const searchWrap = document.querySelector('.search-wrap');
		if (searchWrap) {
			searchWrap.classList.toggle('on');
		}

		// 모든 .slim-select에 대해 padding-left 재적용
		document.querySelectorAll('.slim-select.custom').forEach(select => {
			applyPaddingLeft(select);
		});
	}

	window.toggleSrch = toggleSrch;

	// ✅ 전체 선택 체크박스
	const chkall = document.getElementById('chkall');
	const checkboxes = document.querySelectorAll('input[name="ids[]"]');

	if (chkall) {
		chkall.addEventListener('click', () => {
			checkboxes.forEach(checkbox => {
				checkbox.checked = chkall.checked;
			});
		});
	}

	// ✅ 개별 체크박스 클릭 시
	checkboxes.forEach(checkbox => {
		checkbox.addEventListener('click', () => {
			const allChecked = Array.from(checkboxes).every(cb => cb.checked);
			chkall.checked = allChecked;
		});
	});

	// 🔍 검색어 입력 처리
	const skeyword = document.getElementById('skeyword');
	const skeywordDel = document.getElementById('skeyword-del');

	if (skeyword && skeywordDel) {
		skeyword.addEventListener('input', () => {
			const value = skeyword.value.trim();
			skeywordDel.style.display = value !== '' ? 'inline' : 'none';
		});
	}
});

/*
| ----------------------------------------------------------------------------------------
| 팝업 여닫기 함수입니다.
| ----------------------------------------------------------------------------------------
*/

function openPopup(id, type) {
	if (type === "normal") {
		$(id).attr('data-open-type', 'normal');
		$(id).show();
		$('.popup-bg').show();
	}
	if (type === "fade") {
		$(id).attr('data-open-type', 'fade');
		$(id).fadeIn(200);
		$('.popup-bg').fadeIn(200);
	}

	$("html").css('overflow', 'hidden');
}

window.openPopup = openPopup;

// closePopup 함수
function closePopup(trigger, type) {
	// trigger가 버튼인 경우 해당 팝업을 찾음
	var popup = $(trigger).closest('.popup');

	if (popup.length === 0) return; // 닫을 팝업이 없으면 종료

	if (type === "normal") {
		popup.attr('data-open-type', 'normal');
		popup.hide();
		$('.popup-bg').hide();
	} else if (type === "fade") {
		popup.attr('data-open-type', 'fade');
		popup.fadeOut(200);
		$('.popup-bg').fadeOut(200);
	}

	// 특정 팝업의 내부 상태 초기화
	if (popup.attr('id') === 'popup_findid') {
		popup.find('.findaccount .step2').hide();
		popup.find('.findaccount .step1').show();
	}

	if (popup.attr('id') === 'popup_findpw') {
		popup.find('.findaccount .step2').hide();
		popup.find('.findaccount .step1').show();
	}

	$("html").css('overflow', 'auto');
}

window.closePopup = closePopup;

// 팝업 외부 클릭 감지 및 닫기
document.addEventListener('mouseup', (e) => {
	const popup = e.target.closest('.popup');

	if (popup && !popup.querySelector('.popup-inner')?.contains(e.target)) {
		const type = popup.getAttribute('data-open-type') || 'normal';
		closePopup(popup, type);
	}
});

/*
| ----------------------------------------------------------------------------------------
| ppAlert 함수입니다.
| ----------------------------------------------------------------------------------------
*/
function ppAlert(opts) {
	let alertHTML = '';

	if ($('.alertOverlay2').length > 0) {
		$('.alertOverlay2').remove();
	}

	if ($('.pp-alert').length > 0) {
		$('.pp-alert').remove();
	}

	if (typeof opts == 'string') {
		alertHTML = `
			<div id="alertModal" class="popup pp-alert small-modal w-100 h-100 position-fixed start-0 top-0" style="z-index:9999;">
				<div class="pop-wrap d-flex w-100 h-100 justify-content-center align-items-center p-3">
					<div class="size w-100">
						<div class="popup-inner w-100 p-5 position-relative shadow-sm">
							<div class="pop-cont text-center">
								<div class="txt-box">
									<p id="msg" class="fs16 fw-bold text-center">${opts}</p>
								</div>
								<div class="btn-set d-flex justify-content-center mt30">
									<a href="javascript:;" class="btn btn1 lime user d-flex justify-content-center align-items-center w--50 rounded-3 text-white fs14 fw-bold">확인</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			`
	} else {
		alertHTML = `
		<div ${opts.id ? 'id="' + opts.id + '"' : ''} class="popup pp-alert ${opts.button2 ? ' confirm' : ''} small-modal w-100 h-100 position-fixed start-0 top-0" style="z-index:9999;">
			<div class="pop-wrap d-flex w-100 h-100 justify-content-center align-items-center p-3">
				<div class="size w-100">
					<div class="popup-inner w-100 p-5 position-relative shadow-sm">
						<div class="pop-cont text-center">
							<div class="txt-box">
								<p id="msg2" class="fs16 fw-bold text-center">${opts.text}</p>
							</div>
							<div class="btn-set d-flex justify-content-center mt30 gap-3">
							${opts.button2 ? '<a href="javascript:;" class="btn lime user btn2 d-flex justify-content-center align-items-center w--50 rounded-3 fs14 text-white fw-bold">' + opts.button2.text + '</a>' : ''}
								${opts.button1 ? '<a href="javascript:;" class="btn gr btn1 d-flex justify-content-center align-items-center w--50 rounded-3 fs14 text-white fw-bold">' + opts.button1.text + '</a>' : '<a href="javascript:;" class="btn lime user btn1"확인</a>'}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		`
	}

	$('html').append(alertHTML);

	$('.pp-alert').css('display', 'block');

	// button 클릭
	$('.pp-alert .btn1').on('click', function (e) {
		$('.pp-alert').css('display', 'none');
		if (opts.button1) {
			if (opts.button1.click) opts.button1.click(e);
		}
	});

	if (opts.button2) {
		$('.pp-alert .btn2').on('click', function (e) {
			$('.pp-alert').css('display', 'none');
			if (opts.button2) {
				if (opts.button2.click) opts.button2.click(e);
			}
		});
	}
};
window.ppAlert = ppAlert;


// 전화번호 체크
function setPhone(obj) {
	//010 //replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, ""); 13자리

	var len = obj.value.length;

	if (parseInt(obj.value.search('010')) === 0 || parseInt(obj.value.search('011')) === 0) {

		// console.log('휴대폰번호 체크');
		if (/^010/.test(obj.value)) {
			$(obj).attr('maxlength', 13);
			obj.value = obj.value
			.replace(/[^0-9]/g, '')
			.replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
		} else if (/^011/.test(obj.value)) {
			$(obj).attr('maxlength', 12);
			obj.value = obj.value
			.replace(/[^0-9]/g, '')
			.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
		}
	} else {
		if (/^02/.test(obj.value)) { //서울
			$(obj).attr('maxlength', 12);

			// 가운데 3자리(11자리)
			obj.value = obj.value
			.replace(/[^0-9]/g, '')
			.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");

			// 가운데 4자리(12자리)
			if (len === 12) {
				obj.value = obj.value
				.replace(/[^0-9]/g, '')
				.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
			}
		} else {
			$(obj).attr('maxlength', 13);

			// 가운데 3자리(12자리)
			obj.value = obj.value
			.replace(/[^0-9]/g, '')
			.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");

			// 가운데 4자리(13자리)
			if (len === 13) {
				obj.value = obj.value
				.replace(/[^0-9]/g, '')
				.replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
			}

		}
	}
}

window.setPhone = setPhone;

// 숫자만
function isOnlyNumber(obj) {
	let exp = /[^0-9,]/g;
	if (exp.test(obj.value)) {
		obj.value = "";
		obj.focus();
	}
}

window.isOnlyNumber = isOnlyNumber;

//숫자와 하이픈 표시
function isNumberOrHyphen(obj) {
	let exp = /[^0-9-]/g;
	if (exp.test(obj.value)) {
		alert("숫자와 '-'만 입력가능합니다.");
		obj.value = "";
		obj.focus();
	}
}

window.isNumberOrHyphen = isNumberOrHyphen;

//숫자와 콤마만 표시
function isOnlyCommaNumber(obj) {
	let exp = /[^0-9,]/g;
	if (exp.test(obj.value)) {
		alert("숫자와 ','만 입력가능합니다.");
		obj.value = "";
		obj.focus();
	}
}

window.isOnlyCommaNumber = isOnlyCommaNumber;

//숫자와 점만 표시
function isNumberOrPoint(obj) {
	let exp = /[^0-9.]/g;
	if (exp.test(obj.value)) {
		alert("숫자와 '.'만 입력가능합니다.");
		obj.value = "";
		obj.focus();
	}
}

window.isNumberOrPoint = isNumberOrPoint;

//숫자 하이픈, 엔터만 표시
function isNumberOrHyphenOrEnter(obj) {
	let exp = /[^0-9-\r\n]/g;
	if (exp.test(obj.value)) {
		alert("숫자와 '-'와 엔터키만 가능합니다.");
		obj.value = "";
		obj.focus();
	}
}

window.isNumberOrHyphenOrEnter = isNumberOrHyphenOrEnter;

//사업자 등록번호
function cvtBNumber(obj) {
	let exp = /-/g;
	let number = obj.value.replace(exp, "");
	let num = "";

	if (number.length > 5) {
		num = number.substring(0, 3) + "-" + number.substring(3, 5) + "-" + number.substring(5);
	} else if (number.length > 3) {
		num = number.substring(0, 3) + "-" + number.substring(3);
	} else if (number.length <= 3) {
		num = obj.value;
	}
	obj.value = num;
}

window.cvtBNumber = cvtBNumber;

//법인등록번호
function cvtCNumber(obj) {
	let exp = /-/g;
	let number = obj.value.replace(exp, "");
	let num = "";

	if (number.length > 6) {
		num = number.substring(0, 6) + "-" + number.substring(6);
	} else {
		num = obj.value;
	}
	obj.value = num;
}

window.cvtCNumber = cvtCNumber;

/*
| ----------------------------------------------------------------------------------------
| input custom에 따른 함수입니다.
| ----------------------------------------------------------------------------------------
*/
function handleInputValue(input) {
	input.classList[input.value.trim() === '' ? 'remove' : 'add']('has-value');
}

window.handleInputValue = handleInputValue;

function clearInput(button) {
	const input = button.closest('.ipt-box').querySelector('input');
	input.value = '';
	input.classList.remove('has-value');
}

window.clearInput = clearInput;

function handleInputBlur(input) {
	input.classList.toggle('has-value', input.value.trim() !== '');
}

window.handleInputBlur = handleInputBlur;

/*
| ----------------------------------------------------------------------------------------
| 토글 함수입니다.
| ----------------------------------------------------------------------------------------
*/
function toggleStatus(_this) {
	if ($(_this).hasClass('sort-btn')) {
		$(_this).toggleClass('active');
	} else {
		$(_this).closest('.toggle-box').toggleClass('active');
	}
}

// 전역으로 등록
window.toggleStatus = toggleStatus;

/*
| ----------------------------------------------------------------------------------------
| 카카오, 구글, 네이버 지도 관련 함수입니다.
| ----------------------------------------------------------------------------------------
*/
function initKakaoMap(container, address = null, marker = null, lat = null, lng = null) {
	const el = document.getElementById(container);
	kakao.maps.load(function () {
		function createMap(lat, lng) {
			const map = new kakao.maps.Map(el, {
				center: new kakao.maps.LatLng(lat, lng),
				level : 3
			});

			const markerOptions = {
				position: new kakao.maps.LatLng(lat, lng),
				map     : map
			};

			if (marker) {
				markerOptions.image = new kakao.maps.MarkerImage(
					marker,
					new kakao.maps.Size(40, 40)
				);
			}

			new kakao.maps.Marker(markerOptions);
		}

		if (lat && lng) {
			createMap(lat, lng);
		} else if (address) {
			const geocoder = new kakao.maps.services.Geocoder();
			geocoder.addressSearch(address, function (result, status) {
				if (status === kakao.maps.services.Status.OK) {
					createMap(parseFloat(result[0].y), parseFloat(result[0].x));
				} else {
					console.error('카카오 주소 검색 실패:', address);
				}
			});
		} else {
			console.error('위치 정보가 없습니다.');
		}
	});
}

function initGoogleMap(container, address = null, marker = null, lat = null, lng = null) {
	const el = document.getElementById(container);

	function createMap(element, location) {
		const map = new google.maps.Map(element, {
			center: location,
			zoom  : 18,
			mapId : "d17749e71dfca04fd91a4048" // https://console.cloud.google.com/google/maps-apis/studio/maps 에서 map id 만들어서 넣기
		});

		let contentNode = null;
		if (marker) {
			contentNode = document.createElement('img');
			contentNode.src = marker;
			contentNode.style.width = '40px';
			contentNode.style.height = '40px';
		}

		const markerOptions = {
			position: location,
			map     : map,
			content : contentNode // Node 객체 전달
		};

		new google.maps.marker.AdvancedMarkerElement(markerOptions);
	}

	const latNum = lat !== null ? parseFloat(lat) : null;
	const lngNum = lng !== null ? parseFloat(lng) : null;

	if (!isNaN(latNum) && !isNaN(lngNum)) {
		createMap(el, new google.maps.LatLng(latNum, lngNum));
	} else if (address) {
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode({address: address}, function (results, status) {
			if (status === google.maps.GeocoderStatus.OK) {
				createMap(el, results[0].geometry.location);
			} else {
				console.error('구글 주소 검색 실패:', address);
			}
		});
	} else {
		console.error('위치 정보가 없습니다. 위도/경도 또는 주소를 지정하세요.');
	}
}

function initNaverMap(container, address = null, marker = null, lat = null, lng = null) {
	const el = document.getElementById(container);

	function createMap(lat, lng) {
		const map = new naver.maps.Map(el, {
			center: new naver.maps.LatLng(lat, lng),
			zoom  : 18
		});

		const markerOptions = {
			position: new naver.maps.LatLng(lat, lng),
			map     : map
		};

		if (marker) {
			markerOptions.icon = {
				url       : marker,
				size      : new naver.maps.Size(40, 40),
				scaledSize: new naver.maps.Size(40, 40)
			};
		}

		new naver.maps.Marker(markerOptions);
	}

	if (lat && lng) {
		createMap(lat, lng);
	} else if (address) {
		naver.maps.Service.geocode({address: address}, function (status, response) {
			if (status === naver.maps.Service.Status.OK) {
				const result = response.v2.addresses[0];
				createMap(parseFloat(result.y), parseFloat(result.x));
			} else {
				console.error('네이버 주소 검색 실패:', address);
			}
		});
	} else {
		console.error('위치 정보가 없습니다.');
	}
}

// 전역으로 등록
window.initKakaoMap = initKakaoMap;
window.initGoogleMap = initGoogleMap;
window.initNaverMap = initNaverMap;

function initMap(mapType, mapElement, lng = null, lat = null, address = null, marker = null) {
	if (typeof MAP_KEYS === 'undefined') {
		console.error('MAP_KEYS 객체가 정의되지 않았습니다.');
		return;
	}

	// 지도 타입별 키와 초기화 함수 매핑
	const mapConfig = {
		kakao : {key: MAP_KEYS.kakao, init: initKakaoMap},
		naver : {key: MAP_KEYS.naver, init: initNaverMap},
		google: {key: MAP_KEYS.google, init: initGoogleMap}
	};

	const config = mapConfig[mapType];

	if (!config) {
		console.error('지원하지 않는 mapType:', mapType);
		return;
	}

	if (!config.key) {
		console.warn(`${mapType} 지도 Key가 설정되지 않아 지도 로드 불가`);
		return;
	}

	// 초기화 함수 호출
	config.init(mapElement, address, marker, lat, lng);
}

window.initMap = initMap;